import React from 'react'
import { Button, Stack, Typography } from '@prometheus/components'
import './ForecastYearPicker.scss'

export interface ForecastYearPickerProps {
  /** Currently selected window, in years. */
  years: number
  /** Selectable windows — `getForecastYearOptions(number_of_levels)`. */
  options: number[]
  onSelect: (years: number) => void
  /** Leading label; defaults to "Forecast". */
  label?: string
  className?: string
}

/**
 * The row of year buttons that picks the resource forecast window. Shared by
 * the mine popup and the Galactic Trader so both read as the same control —
 * and, because both sides use `useForecastYears`, they stay in step.
 */
export const ForecastYearPicker = ({
  years,
  options,
  onSelect,
  label = 'Forecast',
  className,
}: ForecastYearPickerProps) => (
  <Stack
    direction="row"
    space="xs"
    className={className ? `forecast-years ${className}` : 'forecast-years'}
  >
    <Typography className="forecast-years__label">{label}</Typography>
    {options.map(option => (
      <Button
        key={option}
        size="xs"
        className="forecast-years__button"
        variant={option === years ? 'primary' : 'light'}
        outline={option !== years}
        aria-pressed={option === years}
        onClick={() => onSelect(option)}
      >
        {option}
      </Button>
    ))}
    <Typography className="forecast-years__label">
      {years === 1 ? 'year' : 'years'}
    </Typography>
  </Stack>
)

export default ForecastYearPicker
